<dx-popup title="Credit" [width]="400" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="credit">
        <dxi-form-item
            dataField="customerId"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: customersDS, displayExpr: 'displayName', valueExpr: 'id' }"
            [label]="{ text: 'Customer' }"
        >
        </dxi-form-item>
        <dxi-form-item dataField="amount" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 } }">
        </dxi-form-item>
        <dxi-form-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"> </dxi-form-item>
    </dx-form>
</dx-popup>
